import { useStoreToggle } from '@printdeal/feature-management/react';
import React, { FC } from 'react';
import { useSegmentation, isCustomerProgramReseller } from '@printdeal/segmentation/react';
import { FormattedMessage } from 'react-intl';
import AccountLink from '../my-account/components/account-dashboard/AccountLink';
import useSystemPages from '../../hooks/useSystemPages';
import NewBadge from './NewBadge';

const CustomerProgramAccountLink: FC = () => {
  const isStoreToggleEnabled = useStoreToggle('drukwerkdeal-nl_printdeal-be')?.featureToggle?.isEnabled;
  const { data: segmentationData } = useSegmentation();
  const [customerProgramsReseller] = useSystemPages('customerProgramsReseller');

  if (!isStoreToggleEnabled || !isCustomerProgramReseller(
    segmentationData?.isReseller,
    segmentationData?.isPartOfCustomerProgram,
  )) {
    return null;
  }

  return (
    <AccountLink
      to={customerProgramsReseller?.path}
      title={(
        <FormattedMessage
          id="header.account.customerPrograms.partnerPro.short"
          defaultMessage="PartnerPro"
        />
        )}
      text="customerPrograms"
      icon="partner-discount"
      badgeAfter={<NewBadge variant="warning" />}
    />
  );
};

export default CustomerProgramAccountLink;
